import React, { Component } from 'react';
import { Form, Input, Select, Upload, Icon, message } from 'antd';
import { connect } from 'react-redux';

import { uploadFile } from '../../../../../actions';

const FormItem = Form.Item;
const Option = Select.Option;

const EditorForm = Form.create({
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },

  mapPropsToFields(props) {
    return {
      newTitle: Form.createFormField({
        ...props.newTitle,
        value: props.newTitle.value,
      }),
      newLanguage: Form.createFormField({
        ...props.newLanguage,
        value: props.newLanguage.value,
      }),
    };
  },

  // onValuesChange(_, values) {
  //   console.log(values);
  // },
})(class extends Component {
  beforeUpload = (file) => {
    const validImage = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!validImage) {
      message.error('Chỉ được tải lên định dạng JPG hoặc PNG!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Kích thước ảnh phải nhỏ hơn 2MB!');
    }
    if (validImage && isLt2M) {
      this.props.uploadFile({ file, type: 'newFeaturedImage', key: 'page' }, this.props.onChange);
    }
    return false;
  }

  render() {
    const { form: { getFieldDecorator }, upload, formItemLayout, newFeaturedImage } = this.props;
    const image = newFeaturedImage.value || (upload.key === 'page' && upload.file && upload.file.location);

    return (
      <Form>
        <FormItem
          {...formItemLayout}
          label="Tiêu đề"
        >
          {getFieldDecorator('newTitle')(
            <Input placeholder="Tiêu đề không được bỏ trống" />
          )}
        </FormItem>
        <FormItem {...formItemLayout} label="Ngôn ngữ">
          {getFieldDecorator('newLanguage')(
            <Select placeholder="Chọn ngôn ngữ">
              <Option key={0} value='vi'>Tiếng Việt</Option>
              <Option key={1} value='en'>Tiếng Anh</Option>
            </Select>
          )}
        </FormItem>  
        <FormItem
          {...formItemLayout}
          label="Ảnh bìa"
        >
          <Upload
            name="avatar"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            beforeUpload={this.beforeUpload}
          >
            {image
              ? <img style={{ width: 228, height: 128 }} src={image} alt="featuredimage" />
              : <div>
                <Icon type={upload.loading ? 'loading' : 'plus'} />
                <div className="ant-upload-text">Tải lên</div>
              </div>}
          </Upload>
        </FormItem>
      </Form>
    );
  }
});

export default connect(state => ({
  upload: state.upload,
}), {
  uploadFile,
})(EditorForm);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Pages/Editor/EditorForm.js